import { PILLARS } from "../../data/ybf/pillars";
import { PILLAR_KPIS } from "../../data/ybf/kpis";
import { fmtInt } from "../../data/ybf/utils";
import { ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PillarCard({ pillarId }) {
  const navigate = useNavigate();
  const p = PILLARS.find((x) => x.id === pillarId);
  const kpis = PILLAR_KPIS[pillarId];
  if (!p) return null;
  const route = `/${pillarId}`;

  return (
    <div
      data-testid={`pillar-card-${pillarId}`}
      onClick={() => navigate(route)}
      className={`relative rounded-2xl border border-slate-200 bg-gradient-to-br ${p.bg} p-5 cursor-pointer hover:shadow-lg hover:border-slate-300 transition-all group overflow-hidden`}
    >
      {/* Accent stripe */}
      <div className="absolute top-0 left-0 right-0 h-1" style={{ background: p.color }} />

      <div className="flex items-start justify-between mb-3">
        <div>
          <div className="text-[10px] uppercase tracking-widest font-bold" style={{ color: p.color }}>
            {p.short} · Pillar
          </div>
          <h3 className="text-xl font-bold text-slate-900 mt-1 leading-tight">{p.name}</h3>
          <p className="text-xs text-slate-600 mt-1">{p.tagline}</p>
        </div>
        <ArrowUpRight
          size={20}
          className="text-slate-400 group-hover:text-slate-700 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
        />
      </div>

      <div className="grid grid-cols-2 gap-2 mt-4">
        {kpis.slice(0, 4).map((k) => (
          <div key={k.key} className="bg-white/70 backdrop-blur rounded-lg p-2.5 border border-white/40">
            <div className="text-[9px] uppercase tracking-wider text-slate-500 font-medium truncate">
              {k.label}
            </div>
            <div className="text-base font-bold text-slate-900 mt-0.5 leading-none">
              {k.unit && k.unit.includes("₹") ? `₹${k.value} Cr` :
               k.unit === "%" ? `${k.value}%` :
               fmtInt(k.value)}
            </div>
          </div>
        ))}
      </div>

      <div className="flex flex-wrap gap-1 mt-4">
        {p.subThemes.map((t) => (
          <span
            key={t}
            className={`text-[9px] px-1.5 py-0.5 rounded-full ${p.chipBg} ${p.chipText} font-medium`}
          >
            {t}
          </span>
        ))}
      </div>
    </div>
  );
}
